import { useEffect, useState } from "react";
import { categoriesModel } from "src/modules/categories/entity/categories/CategoryModel";
import { ICategory } from "src/modules/categories/entity/categories/ICategory";
import {useNavigate, useSearchParams} from "react-router-dom";
import {toastService} from "../../../libraries/toast";
import {useUiContext} from "../../../UIProvider";
import {findCategory} from "../../../utils/Utils";
import { createCategoryUseCase } from "../useCases/createCategoryUseCase";
import { z } from 'zod';
import { getCategoriesUseCase } from "../useCases/getCategoriesUseCase";

export const useCategoryCreating = () => {
    const { t } = useUiContext();
    const [ searchParams ] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ name: '', description: '', slug: '', parent_id: '', image: '' });
    const category = categoriesModel.category;
    const categories = categoriesModel.categories;
    const navigate = useNavigate();

    const categorySchema = z.object({
        name: z.string().min(1, { message: t('common.error.notEmpty') }),
        description: z.string().min(1, { message: t('common.error.notEmpty') }),
        // slug: z.string().min(1, { message: t('common.error.notEmpty') }),
        parent_id: z.union([z.number(), z.string()]).nullable().optional(),
        image: z.any().refine((file) => (file && file.size && file.size <= 1 * 1024 * 1024), { message: "File size should be less than or equal to 1 MB" }).nullable().optional(),
    });

    const parentId = searchParams.get('parentId');

    useEffect(() => {
        if (!categories.length) {
            getCategoriesUseCase({ tree: true });
        }
        categoriesModel.category = { name: '', description: '', parent_id: parentId ? Number(parentId) : null, slug: '', available: false, image: null } as any;
        return () => { categoriesModel.category = null; }
    }, []);

    const parent = findCategory(categories, category?.parent_id);
    const options = categories?.map((item: ICategory) => ({ id: item.id, name: item.name, value: item.id }));

    const onChange = (value: string, field: string) => {
        if (categoriesModel.category) {
            categoriesModel.category = { ...categoriesModel.category, [field]: value };
            setErrors((prev) => ({ ...prev, [field]: '' }));
        }
    }

    const onSelectCategory = (selectedKeysValue: string, node: any) => {
        if (categoriesModel.category) {
            categoriesModel.category = { ...categoriesModel.category, parent_id: node.value };
        }
    };

    const onChangeCategory = () => {
        if (categoriesModel.category) {
            categoriesModel.category = { ...categoriesModel.category, parent_id: null };
        }
    };

    const onCreateCategory = async () => {
        setLoading(true);
        const result: any = categorySchema.safeParse({ ...categoriesModel.category });
        if (result.success && categoriesModel.category) {
            const result = await createCategoryUseCase({
                name: category?.name,
                description: category?.description,
                parent_id: category?.parent_id,
                image: category?.image,
            } as any);
            if (!result?.isError) {
                toastService.onSuccess(t('categories.message.categoryCreated'));
                navigate(`/dashboard/categories`);
            }
        } else {
            result.error.errors.map((item: any) => {
                setErrors((prev) => ({ ...prev, [item.path[0]]: item.message }));
            })
        }
        setLoading(false);
    }

    return { category, categories, options, parent, errors, onChange, onSelectCategory, onChangeCategory, onCreateCategory };

}